module.exports = __webpack_public_path__ + "4c4826e430e131df7a6889c0bf6859b5.png";